import React from 'react';
import styles from './Tile.module.css';

type Span = 2 | 3 | 4 | 6;
type Tone = 'brick' | 'ochre' | 'olive' | 'ink' | 'surface';

interface TileProps {
  span?: Span;
  tone?: Tone;
  label?: string;
  glyph?: string;
  children?: React.ReactNode;
  className?: string;
}

const spanClass: Record<Span, string> = {
  2: styles.s2,
  3: styles.s3,
  4: styles.s4,
  6: styles.s6,
};

const toneClass: Record<Tone, string> = {
  brick: styles.toneBrick,
  ochre: styles.toneOchre,
  olive: styles.toneOlive,
  ink: styles.toneInk,
  surface: styles.toneSurface,
};

const Tile: React.FC<TileProps> = ({ span = 3, tone, label, glyph, children, className }) => {
  const classes = [
    styles.mod,
    spanClass[span],
    tone ? toneClass[tone] : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      {label && (
        <div className={styles.mlabel}>
          <span>{label}</span>
          {glyph && <span>{glyph}</span>}
        </div>
      )}
      {children}
    </div>
  );
};

export default Tile;
